document.addEventListener('DOMContentLoaded', function () {
  const badge = document.getElementById('FreeShippingBadge');
  const textEl = document.getElementById('FreeShippingText');
  const progressEl = document.getElementById('FreeShippingProgress');

  if (!badge) return;

  const THRESHOLDS = {
    SEK: 49900,  // 499 kr
    NOK: 49900,  // 499 kr (NOK)
    EUR: 4500,   // 45 €
    GBP: 4000,   // £40
    USD: 4900    // $49
  };

  const CURRENCY_FORMAT = {
    SEK: { locale: 'sv-SE', symbol: ' kr', position: 'after' },
    NOK: { locale: 'nb-NO', symbol: ' kr', position: 'after' },
    EUR: { locale: 'de-DE', symbol: ' €', position: 'after' },
    GBP: { locale: 'en-GB', symbol: '£', position: 'before' },
    USD: { locale: 'en-US', symbol: '$', position: 'before' }
  };

  const TEXT = {
    sv: {
      away: (amount) => `${amount} kvar till fri frakt`,
      complete: 'Du har fri frakt! 🎉',
      fallback: 'Fri frakt över 499 kr',
      discount: 'Få 10% rabatt på ditt första köp med kod WELCOME10'
    },
    en: {
      away: (amount) => `${amount} away from free shipping`,
      complete: 'You have free shipping! 🎉',
      fallback: 'Free shipping over $49',
      discount: 'Get 10% off of your first order with code WELCOME10'
    }
  };

  const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'SEK';
  const locale = (window.Shopify && window.Shopify.locale) || 'sv';
  const lang = TEXT[locale] ? locale : 'en';
  const threshold = THRESHOLDS[currency] || THRESHOLDS.SEK;
  const fmt = CURRENCY_FORMAT[currency] || CURRENCY_FORMAT.SEK;

  let currentCartTotal = 0;
  let showingDiscount = false;
  const FADE_MS = 350;

  function formatMoney(cents) {
    const amount = cents / 100;
    const formatted = amount.toLocaleString(fmt.locale);
    return fmt.position === 'before' ? fmt.symbol + formatted : formatted + fmt.symbol;
  }

  function setHeaderHeight() {
    const header = document.querySelector('header.site-header');
    if (header) {
      document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
    }
  }

  function applyShippingContent() {
    const remaining = threshold - currentCartTotal;
    const percent = Math.min((currentCartTotal / threshold) * 100, 100);

    progressEl.style.width = percent + '%';
    progressEl.style.display = '';

    if (remaining <= 0) {
      textEl.textContent = TEXT[lang].complete;
      badge.classList.add('is-complete');
    } else {
      textEl.textContent = TEXT[lang].away(formatMoney(remaining));
      badge.classList.remove('is-complete');
    }
  }

  function applyDiscountContent() {
    progressEl.style.display = 'none';
    badge.classList.remove('is-complete');
    textEl.textContent = TEXT[lang].discount;
  }

  // Fades the text out, swaps the content, then fades back in.
  // Used both for the shipping/discount rotation and for live cart updates,
  // so every content change looks smooth instead of snapping.
  function swapContent(applyFn) {
    textEl.classList.add('is-fading');
    setTimeout(function () {
      applyFn();
      setHeaderHeight();
      textEl.classList.remove('is-fading');
    }, FADE_MS);
  }

  function updateBadge(cartTotal) {
    const changed = cartTotal !== currentCartTotal;
    currentCartTotal = cartTotal;
    if (!showingDiscount) {
      if (changed) {
        swapContent(applyShippingContent);
      } else {
        applyShippingContent();
      }
    }
  }

  function fetchCart() {
    fetch('/cart.js')
      .then((res) => res.json())
      .then((cart) => {
        updateBadge(cart.total_price);
      })
      .catch(() => {
        textEl.textContent = TEXT[lang].fallback;
      });
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight);
  fetchCart();

  // Rotate between shipping status and discount code every 3 seconds, with a smooth fade
  setInterval(function () {
    showingDiscount = !showingDiscount;
    swapContent(showingDiscount ? applyDiscountContent : applyShippingContent);
  }, 3000);

  document.addEventListener('submit', function (e) {
    if (e.target.matches('form[action*="/cart/add"]')) {
      setTimeout(fetchCart, 400);
    }
  });
});